module.exports = __webpack_public_path__ + "img/iconfont.2905b8c7.svg";